<template>
  <div v-if="visible" class="plus-wf-anchor-layer">
    <div class="plus-wf-anchor-layer__backdrop" @click="$emit('close')"></div>
    <div class="plus-wf-anchor-layer__panel" :style="panelPositionStyle" @click.stop>
      <div class="flex items-center justify-between gap-2 px-5 pt-5 pb-3">
        <div class="text-lg font-black tracking-tight text-gray-100">画布节点</div>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-black/30 text-white/70 hover:text-white"
          @click="$emit('close')"
        >
          <i class="fas fa-times text-[12px]"></i>
        </button>
      </div>
      <p class="px-5 pb-3 text-[11px] leading-snug text-gray-500">
        选择要在画布中创建并执行的节点类型
      </p>
      <div class="max-h-[min(52vh,360px)] overflow-y-auto px-3 pb-4">
        <button
          v-for="opt in options"
          :key="opt.type"
          type="button"
          class="mb-1 flex w-full items-center gap-3 rounded-2xl border px-4 py-3 text-left transition-colors"
          :class="
            opt.type === nodeType
              ? 'border-white/15 bg-white/[0.10]'
              : 'border-transparent hover:bg-white/[0.06]'
          "
          @click="onPick(opt)"
        >
          <div
            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.06] text-gray-200"
          >
            <i :class="[opt.icon, 'text-[14px]']"></i>
          </div>
          <div class="min-w-0 flex-1">
            <div class="truncate text-[14px] font-bold text-gray-100">{{ opt.label }}</div>
            <div class="truncate text-[12px] text-gray-400">{{ opt.desc }}</div>
          </div>
          <i
            v-if="opt.type === nodeType"
            class="fas fa-check text-[12px] text-fuchsia-300/90"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import workflowAnchoredModalMixin from '@/mixins/workflowAnchoredModalMixin'
import { CANVAS_LAUNCH_NODE_OPTIONS } from '@/constants/canvasLaunchNodeOptions'

export default {
  name: 'WorkflowCanvasNodePickerModal',
  mixins: [workflowAnchoredModalMixin],
  props: {
    visible: { type: Boolean, default: false },
    nodeType: { type: String, default: '' },
    options: {
      type: Array,
      default: () => CANVAS_LAUNCH_NODE_OPTIONS
    }
  },
  computed: {
    panelPositionStyle() {
      return this.buildPanelPositionStyle()
    }
  },
  methods: {
    getPanelLayoutOptions() {
      return { panelWidth: 320, panelMaxHeight: 420, gap: 10, align: 'left' }
    },
    onPick(opt) {
      if (!opt || !opt.type) return
      this.$emit('select', opt)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.plus-wf-anchor-layer {
  position: fixed;
  inset: 0;
  z-index: 10050;
  pointer-events: none;
}
.plus-wf-anchor-layer__backdrop {
  position: fixed;
  inset: 0;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.12);
}
.plus-wf-anchor-layer__panel {
  position: fixed;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(27, 27, 31, 0.98);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.65);
}
</style>
